const settings = {
  api:
    (process.env.NODE_ENV === 'production' &&
      'https://elwarsha-api.minarina.com/') ||
    'http://localhost:4000/'
};

export default settings;
